import ExamService from '@/services/exam.service';
import axios from "axios";

export const examModule = {
    namespaced: true,
    state: {
        requests: [],
        exam: {},
        exams: new Map(),
        examResult: {},
        examResults: new Map(),
        participatedExam: new Map(),
        examInteraction: {},
        labels: new Map(),
        label: {},
        questions: new Map(),
        activeQuestion: {},
        labelQuestions: new Map(),
        availableExams: new Map(),
        allowedStudents: {},
        allowedTeachers: {},
        examInteractionReportObj: "",
        examAttendanceReportObj: "",
        userScores: new Map(),
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async copyExam({commit, dispatch}, examId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "copyExam");
            return ExamService.copyExam(axiosSource, examId).then(
                async data => {
                    commit('insertExam', data)
                    await dispatch('clearRequest', "copyExam");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createExam({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createExam");
            return await ExamService.createExam(axiosSource, data).then(
                async data => {
                    commit('insertExam', data)
                    await dispatch('clearRequest', "createExam");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateExam({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateExam");
            return ExamService.updateExam(axiosSource, data).then(
                async data => {
                    commit('updateExamData', data)
                    await dispatch('clearRequest', "updateExam");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteExam({commit, dispatch}, examId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteExam");
            return ExamService.deleteExam(axiosSource, examId).then(
                async data => {
                    commit('removeExamFromList', examId)
                    await dispatch('clearRequest', "deleteExam");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getExam({commit, dispatch}, examId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getExam");
            return ExamService.getExam(axiosSource, examId).then(
                async data => {
                    commit('updateActiveExam', data)
                    await dispatch('clearRequest', "getExam");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listExams({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listExams");
            return ExamService.listExams(axiosSource).then(
                async data => {
                    commit('updateExamsList', data);
                    await dispatch('clearRequest', "listExams");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listResultsExam({commit, dispatch}, examId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listResultsExam");
            return ExamService.listResultsExam(axiosSource, examId).then(
                async data => {
                    commit('updateExamResultsList', data);
                    await dispatch('clearRequest', "listResultsExam");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getResultExam({commit, dispatch}, {examId, resultId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getResultExam");
            return ExamService.getResultExam(axiosSource, examId, resultId).then(
                async data => {
                    commit('updateExamResult', data)
                    await dispatch('clearRequest', "getResultExam");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getStudentResultExam({commit, dispatch}, examId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getStudentResultExam");
            return ExamService.getStudentResultExam(axiosSource, examId).then(
                async data => {
                    commit('updateExamResult', data)
                    await dispatch('clearRequest', "getStudentResultExam");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listParticipatedExam({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listParticipatedExam");
            return ExamService.listParticipatedExam(axiosSource).then(
                async data => {
                    commit('updateExamParticipatedList', data);
                    await dispatch('clearRequest', "listParticipatedExam");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getInteractionExam({commit, dispatch}, examId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getInteractionExam");
            return ExamService.getInteractionExam(axiosSource, examId).then(
                async data => {
                    commit('updateExamInteraction', data)
                    await dispatch('clearRequest', "getInteractionExam");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listAvailableExams({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listAvailableExams");
            return ExamService.listAvailableExams(axiosSource).then(
                async data => {
                    commit('updateAvailableExamsList', data);
                    await dispatch('clearRequest', "listAvailableExams");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listAllowedStudentsForExam({commit, dispatch}, examId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listAvailableExams");
            return ExamService.listAllowedStudentsForExam(axiosSource, examId).then(
                async data => {
                    commit('updateAllowedStudentsForExam', data)
                    await dispatch('clearRequest', "listAvailableExams");
                    return Promise.resolve(data)
                },
                error => {
                    return Promise.reject(error)
                }
            )
        },
        async syncAllowedStudentsForExam({commit, dispatch}, {examId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "syncAllowedStudentsForExam");
            return ExamService.syncAllowedStudentsForExam(axiosSource, examId, data).then(
                async data => {
                    commit('updateAllowedStudentsForExam', data)
                    await dispatch('clearRequest', "syncAllowedStudentsForExam");
                    return Promise.resolve(data)
                },
                error => {
                    return Promise.reject(error)
                }
            )
        },
        async listAllowedTeachersForExam({commit, dispatch}, examId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listAllowedTeachersForExam");
            return ExamService.listAllowedTeachersForExam(axiosSource, examId).then(
                async data => {
                    commit('updateAllowedTeachersForExam', data)
                    await dispatch('clearRequest', "listAllowedTeachersForExam");
                    return Promise.resolve(data)
                },
                error => {
                    return Promise.reject(error)
                }
            )
        },
        async syncAllowedTeachersForExam({commit, dispatch}, {examId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "syncAllowedTeachersForExam");
            return ExamService.syncAllowedTeachersForExam(axiosSource, examId, data).then(
                async data => {
                    commit('updateAllowedTeachersForExam', data)
                    await dispatch('clearRequest', "syncAllowedTeachersForExam");
                    return Promise.resolve(data)
                },
                error => {
                    return Promise.reject(error)
                }
            )
        },
        async listLabels({commit, dispatch}, examId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listLabels");
            return ExamService.listLabels(axiosSource, examId).then(
                async data => {
                    commit('updateLabelsList', data);
                    await dispatch('clearRequest', "listLabels");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createLabel({commit, dispatch}, {examId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createLabel");
            return ExamService.createLabel(axiosSource, examId, data).then(
                async data => {
                    commit('insertLabel', data)
                    await dispatch('clearRequest', "createLabel");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateLabel({commit, dispatch}, {examId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateLabel");
            return ExamService.updateLabel(axiosSource, examId, data).then(
                async data => {
                    commit('updateLabelData', data)
                    await dispatch('clearRequest', "updateLabel");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateLabelLimitation({commit, dispatch}, {examId, label}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateLabelLimitation");
            return ExamService.updateLabelLimitation(axiosSource, examId, label).then(
                async data => {
                    commit('updateLabelLimitationData', data)
                    await dispatch('clearRequest', "updateLabelLimitation");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteLabel({commit, dispatch}, {examId, labelId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteLabel");
            return ExamService.deleteLabel(axiosSource, examId, labelId).then(
                async data => {
                    commit('removeLabelFromList', labelId)
                    await dispatch('clearRequest', "deleteLabel");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listQuestions({commit, dispatch}, examId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listQuestions");
            return ExamService.listQuestions(axiosSource, examId).then(
                async data => {
                    commit('updateQuestionsList', data);
                    await dispatch('clearRequest', "listQuestions");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listQuestionsByLabelId({commit, dispatch}, {examId, labelId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listQuestionsByLabelId");
            return ExamService.listQuestionsByLabelId(axiosSource, examId, labelId).then(
                async data => {
                    commit('updateLabelQuestionsList', data);
                    await dispatch('clearRequest', "listQuestionsByLabelId");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createQuestion({commit, dispatch}, {examId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createQuestion");
            return ExamService.createQuestion(axiosSource, examId, data).then(
                async data => {
                    commit('insertQuestion', data)
                    await dispatch('clearRequest', "createQuestion");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async importQuestion({commit, dispatch}, {examId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "importQuestion");
            return ExamService.importQuestion(axiosSource, examId, data).then(
                async data => {
                    commit('appendQuestionsList', data)
                    await dispatch('clearRequest', "importQuestion");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateQuestion({commit, dispatch}, {examId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateQuestion");
            return ExamService.updateQuestion(axiosSource, examId, data).then(
                async data => {
                    commit('updateQuestionData', data)
                    await dispatch('clearRequest', "updateQuestion");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteQuestion({commit, dispatch}, {examId, questionId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteQuestion");
            return ExamService.deleteQuestion(axiosSource, examId, questionId).then(
                async data => {
                    commit('removeQuestionFromList', questionId)
                    await dispatch('clearRequest', "deleteQuestion");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getExamInteractionReport({commit, dispatch}, examId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getExamInteractionReport");
            return ExamService.examInteractionsReport(axiosSource, examId).then(
                async data => {
                    commit('updateExamInteractionReportObj', data)
                    await dispatch('clearRequest', "getExamInteractionReport");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getExamAttendanceReport({commit, dispatch}, examId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getExamAttendanceReport");
            return ExamService.examAttendanceReport(axiosSource, examId).then(
                async data => {
                    commit('updateExamAttendanceReportObj', data)
                    await dispatch('clearRequest', "getExamAttendanceReport");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async submitUserScore({commit, dispatch}, {examId, interactionId, userScore}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "submitUserScore");
            return ExamService.submitUserScore(axiosSource, examId, interactionId, userScore).then(
                async data => {
                    commit('updateExamResult', data)
                    await dispatch('clearRequest', "submitUserScore");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateExamsList(state, data) {
            state.exams = new Map()
            for (const entity of data) {
                state.exams.set(entity.id, entity)
            }
        },
        updateExamResultsList(state, data) {
            state.examResults = new Map()
            for (const entity of data) {
                state.examResults.set(entity.id, entity)
            }
        },
        updateExamParticipatedList(state, data) {
            state.participatedExam = new Map()
            for (const entity of data) {
                state.participatedExam.set(entity.id, entity)
            }
        },
        updateExamResult(state, data) {
            state.examResult = data
        },
        updateExamInteraction(state, data) {
            state.examInteraction = data
        },
        insertExam(state, data) {
            const arr = Array.from(state.exams);
            arr.splice(0, 0, [data.id, data]);
            state.exams = new Map(arr)
        },
        updateExamData(state, data) {
            state.exams.set(data.id, data)
        },
        removeExamFromList(state, examId) {
            state.exams.delete(examId)
        },
        updateActiveExam(state, data) {
            state.exam = data;
        },
        updateAvailableExamsList(state, data) {
            state.availableExams = new Map()
            for (const entity of data) {
                state.availableExams.set(entity.id, entity)
            }
        },
        updateAllowedStudentsForExam(state, data) {
            state.allowedStudents = data
        },
        updateAllowedTeachersForExam(state, data) {
            state.allowedTeachers = data
        },
        updateLabelsList(state, data) {
            state.labels = new Map()
            for (const entity of data) {
                state.labels.set(entity.id, entity)
            }
        },
        insertLabel(state, data) {
            state.labels.set(data.id, data)
        },
        updateLabelData(state, data) {
            state.labels.set(data.id, data)
        },
        updateLabelLimitationData(state, data) {
            state.label = data
        },
        removeLabelFromList(state, labelId) {
            state.labels.delete(labelId)
        },
        updateQuestionsList(state, data) {
            state.questions = new Map()
            for (const entity of data) {
                state.questions.set(entity.id, entity)
            }
        },
        updateLabelQuestionsList(state, data) {
            state.labelQuestions = new Map()
            for (const entity of data.questions) {
                state.labelQuestions.set(entity.id, entity)
            }
        },
        appendQuestionsList(state, data) {
            for (const entity of data) {
                state.questions.set(entity.id, entity)
            }
        },
        insertQuestion(state, data) {
            state.questions.set(data.id, data)
            if (data.id === state.activeQuestion.id) {
                state.activeQuestion = data
            }
        },
        updateQuestionData(state, data) {
            state.questions.set(data.id, data)
            if (data.id === state.activeQuestion.id) {
                state.activeQuestion = data
            }
        },
        removeQuestionFromList(state, questionId) {
            state.questions.delete(questionId)
        },
        updateExamInteractionReportObj(state, data) {
            state.examInteractionReportObj = data
        },
        updateExamAttendanceReportObj(state, data) {
            state.examAttendanceReportObj = data
        },
    }
};